import { colors } from 'pages/new-questions/styles/common';
import styled from 'styled-components';

export const ClientBubble = styled.div`
  width: 100%;
  background: #5768ff;
  display: flex;
  align-items: flex-start;
  padding: 18px;
  gap: 8px;
  margin-bottom: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
`;

export const ClientLabel = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.01em;
  color: ${colors.userIconDecision};
`;

export const ClientMessage = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.02em;
  color: ${colors.white};
  margin-top: 8px;
`;
